import { render, staticRenderFns } from "./LoadingDialog.vue?vue&type=template&id=5f79f9e5&"
import script from "./LoadingDialog.vue?vue&type=script&lang=js&"
export * from "./LoadingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports